import React, { Component } from "react";

class Terms extends Component {
  render() {
    const { className } = this.props || "";
    return (
      <div className="container">
        <div className={`term-page ${className}`}>
          <h4>Terms of Use</h4>
          <p className="bold">
            These Terms of Use (“Terms”) govern your use of our website{" "}
            <a href="https://www.mylocale.co.uk">www.mylocale.co.uk</a>, its
            associated mobile applications or other affiliated digital products
            offered by us, both in their current form and any future versions
            (together the “Apps”), your use of the platform for ordering food,
            drinks and other goods which is offered through the Apps (the
            “Service”) and your relationship with Local E Rewards Limited (“we”,
            “us” or “Local E”). Please read these Terms carefully as they affect
            your rights and liabilities under the law.
          </p>
          <p className="bold">
            If you do not agree to these Terms, please do not use the Service,
            access the Apps or register as a user - otherwise you will be
            treated as having agreed to these Terms.
          </p>
          <p className="bold">
            Please also see our <a href="/privacy">Privacy Notice</a> for
            information about how we collect and use your personal data.
          </p>
          <h4>1.Introduction</h4>
          <p>
            1.1 The Apps provide access to an online product ordering service,
            available to the public for personal use, which provides its
            registered users with the ability to place an order{" "}
            <b className="bold">(“Order”)</b> for food, drinks and other goods
            or products <b className="bold">(“Products”)</b> from providers who
            are listed on the Apps <b className="bold">(“Providers”).</b>
          </p>
          <p>
            1.2 These Terms will apply to registered users and to those who
            simply view the Apps without registration
            <b className="bold">(“you”)</b>.
          </p>
          <p>
            1.3 By accessing and using the Apps and the Service, you agree to be
            bound by these Terms in full.
          </p>
          <p>
            1.4 You are responsible for ensuring that all persons who access the
            Apps or the Service through your mobile device or internet
            connection are aware of these Terms, and that they comply with them.
          </p>
          <p>
            1.5 By using the Apps and indicating acceptance of these Terms, you
            are representing that you are at least 16 years of age and that you
            understand and agree to be bound by these Terms.
          </p>
          <p>
            1.6 If you are accepting these Terms on behalf of an enterprise,
            organisation or business then you agree and accept that these Terms
            will be binding on all personnel who use the Service of the Apps on
            behalf of that enterprise, organisation or business.
          </p>
          <p>
            1.7 Please note that these Terms may be amended from time to time.
            Notification of any changes will be made by us posting new terms
            onto the Apps as necessary. In continuing to use the Service you
            confirm that you accept the then current Terms in full at the time
            you use the Service. If you do not accept Terms which we have varied
            then you must cancel your registration and cease using the Service.
            If you continue to use the Service without notifying us of your
            objections you will be deemed to have accepted the varied Terms.
          </p>

          <h4>2.Registration</h4>
          <p>
            2.1 In order to use the Service, you must register for an account{" "}
            <b className="bold">(“Account”)</b> on the Apps with your username
            and email address, which must also be verified. [Users can also
            register with the Service and login in to the Apps via Facebook or
            Twitter, which will also act as verification of a user’s details]
          </p>
          <p>
            2.2 When you register as a user we will ask for some of your
            personal information, including payment information. Any personal
            information you provide to us will be handled in accordance with our
            Privacy Notice, which can be viewed <a href="/privacy">here.</a>
          </p>
          <p>
            2.3 If you register to use the Apps as a user you will be asked to
            create a password. In order to prevent fraud, you must keep this
            password confidential and must not disclose it or share it with
            anyone. If you know or suspect that someone else knows your password
            you should notify us by contacting{" "}
            <a href="mailto:support@mylocale.co.uk">support@mylocale.co.uk</a>{" "}
            and change your password immediately.
          </p>
          <p>
            2.4 Alternatively you can gain authorised access to your Account by
            first logging into another service that we partner with, such as
            Facebook or Twitter. In order to prevent fraud, you must keep all
            passwords and other access details for these third party services
            confidential and must not disclose them or share them with anyone.
            If you suspect anyone has access to any of your third party services
            that we link to, you should notify us by contacting{" "}
            <a href="mailto:support@mylocale.co.uk">support@mylocale.co.uk</a>.
          </p>
          <p>
            2.5 You agree that all information that you supply to us will be
            accurate, complete and kept up to date at all times. We may use the
            information provided to us to contact you.
          </p>
          <p>
            2.6 You may receive messages from us via notifications on the Apps,
            emails and/or SMS. You will be able to control the ability to
            receive these messages from your Account settings.
          </p>
          <p>
            2.7 Users may delete their Account at any time. We reserve the right
            the cancel your registration for an Account at any time for any
            reason.
          </p>

          <h4>3.Placing an Order through the Service</h4>
          <p>
            3.1 Users who have not registered for an Account are able to search
            for Providers and view Products but will not be able to place an
            Order.
          </p>
          <p>
            3.2 If you have registered for an Account you are able to select
            Products for either collection from the Provider or delivery by the
            Provider to your chosen address. We are not responsible for ensuring
            that Products listed on the Apps are described or priced accurately,
            and such descriptions and prices are subject to change.
          </p>
          <p>
            3.3 When you confirm that you wish to place an Order your payment
            details will need to be authorised. When your payment details have
            been authorised the details of your Order will be sent to the
            Provider.
          </p>
          <p>
            3.4 When the Provider accepts your Order we will send you a
            confirmation email on the Provider’s behalf and at that point a
            contract is created between you and the Provider for provision of
            the ordered Products (we act as an agent on behalf of our
            Providers).
          </p>

          <h4>4.Cancellation</h4>
          <p>
            4.1 If you wish to cancel your Order after you receive the
            confirmation email then you must communicate this request to the
            Provider [or to Local E via the Apps]. We provide no guarantee that
            your cancellation will be accepted or that a refund of cash or
            eCoins used to place your Order will be given. If the Provider has
            already started preparing your Order then your request for a
            cancellation will not be accepted.
          </p>
          <p>
            4.2 If an Order is delivered to the address you provided when
            placing your Order and you have not collected the Order from that
            location within 10 minutes of the Order’s arrival then you will not
            be entitled to a refund if you do not receive the Order.
          </p>

          <h4>5.Ordered Products</h4>
          <p>
            5.1 If you have an allergy to a certain substance then you must
            contact the Provider in question directly before placing your Order
            if your Order contains food or drink products. We are not
            responsible for checking the allergen information of the Products
            offered by our Providers.
          </p>
          <p>
            5.2 If you order any Products which contain alcohol then you must be
            18 years old or over and must be able to present a valid proof of
            age ID document either on collection or when accepting delivery of
            your Order.
          </p>

          <h4>6.Collecting and spending eCoins</h4>
          <p>
            6.1 When you place an Order you may collect credits{" "}
            <b className="bold">(“eCoins”)</b> which can be used to purchase, or
            contribute towards, future Orders. Not all Products available via
            the Service will allow you to collect eCoins.
          </p>
          <p>
            6.2 When you place an order, eCoins collected count as an issuance of a 
            multi-purpose voucher by Local E Rewards. eCoins can only be 
            redeemed subject to the availability of Providers and at the 
            discretion of Local E Rewards Ltd.
          </p>
          <p>
            6.3 eCoins which are earned for a review are issued at the time an
            order is accepted. These eCoins cannot be spent until a review of
            the restaurant is completed. If no restaurant review is completed
            within three days the eCoins will be declared expired.
          </p>
          <p>
            6.4 Details of how the eCoins you earn for an Order will be
            calculated will be published on the Apps and Website and will be
            accessible to you before you submit an Order. We reserve the right
            to amend the value of eCoins collected at any time.
          </p>
          <p>
            6.5 The total number of eCoins you have collected and their expiry
            date can be viewed by checking your Account details. eCoins earned
            for ordering food will expire at the end of the calendar year after
            the next calendar year and cannot be used towards future Orders. For
            the avoidance of doubt if you earn eCoins on the 21 December 2019,
            the eCoins will expire at the end of 31st December 2021.
          </p>
          <p>
            6.6 Except as may be authorised at our sole discretion or as
            provided for under these Terms, eCoins are not transferable in any
            form or in any way and are not redeemable for cash, and any
            purported transfer or other disposition of your eCoins will be
            invalid and such action will be a breach of these Terms.
          </p>

          <h4>7.Acceptable Use Policy</h4>
          <p>
            7.1 Please note that the Service and the information provided on the
            Apps is strictly for general information purposes only and should
            not be taken as advice on which you can rely. No liability is
            accepted for any loss or damage which may result from such reliance.
          </p>
          <p>
            7.2 You must not use the Service or the Apps for any illegal,
            unethical or immoral purposes. We reserve the right to remove any
            Account at our discretion at any time, without giving reasons if we
            suspect that an Account is being operated in breach of these Terms.
          </p>
          <p>
            7.3 We grant you a limited licence to access and make personal use
            of the Apps and the Service, but not to modify the Apps or any
            software which we use to operate the Service, or any portion of it,
            except with our express written consent.
          </p>
          <h4>8.Content</h4>
          <p>
            8.1 The Service allows for certain users to create content to be
            distributed by the Service, for instance users may post reviews
            about Providers and share these with other users. Any content which
            is distributed by the Service or which you integrate with the
            Service (for instance by placing a hyperlink to our Apps within your
            own content), which we refer to as “Content” in these Terms, must
            comply with our content standards, which are set out below:
          </p>
          <p>
            8.2 You agree that any Content which will be integrated with the
            Service or distributed by the Service will be your own creation or
            will be Content which you are entitled to use and will not be used
            in breach of any intellectual property rights.
          </p>
          <p>
            8.3 Any Content will be your personal responsibility. You will be
            personally liable for all claims relating to defamation, breach of
            intellectual property, privacy or any other claim arising from your
            Content.
          </p>
          <p>
            8.4 You agree to indemnify us in relation to any liability we may
            suffer as a result of any claims relating to defamation, breach of
            intellectual property, privacy or any other claim arising from your
            Content.
          </p>
          <p>
            8.5 You agree that you will not publish any offensive, inaccurate,
            misleading, defamatory, fraudulent or illegal Content, which:
          </p>
          <div style={{ paddingLeft: "15px" }}>
            <p>
              8.5.1 involves the transmission of {'"'}junk mail{'"'}, {'"'}chain
              letters{'"'} or unsolicited mass mailing or {'"'}spamming{'"'};
            </p>
            <p>
              8.5.2 promotes information that you know to be false or
              misleading;
            </p>
            <p>
              8.5.3 contains personal information e.g. names or contact details
              (unless permission has been sought from the holder of the relevant
              personal information); or
            </p>
            <p>
              8.5.4 engages in commercial activities and/or sales, such as
              contests, sweepstakes, barter, advertising and pyramid schemes.
            </p>
          </div>
          <p>
            8.6 By creating or integrating your Content with the Service you
            agree that we will be entitled to use such Content for the purposes
            of delivering or marketing the Service. We reserve the right to
            investigate and remove any Content at any time and for any reason.
          </p>

          <h4>9.Viruses, hacking and other offences</h4>
          <p>
            9.1 You agree not to upload any files or post, distribute or publish
            any files on the Apps or while using the Service that contain
            viruses, corrupted files, or malicious code or any other similar
            software or programs that may damage the operation of another{"'"}s
            computer and electronic device.
          </p>
          <p>
            9.2 We will not be liable for any loss or damage caused by viruses,
            a distributed denial-of-service attack or other technologically
            harmful material that may infect your computer equipment, computer
            programs, data or other proprietary material due to your use of our
            Apps or the Service or to your downloading of any material posted on
            it, or on any website linked to it.
          </p>
          <h4>10.Availability</h4>
          <p>
            10.1 Although we aim to offer you the best service possible, we make
            no promise that our Service will meet your requirements. We cannot
            guarantee that the Service will be fault-free or that information
            contained on the Apps will be kept up to date. All Products listed
            on the Apps are subject to availability from our Providers.
          </p>
          <p>
            10.2 If a fault occurs with the Apps or the Service you should
            report it to hello@mylocale.co.uk and we will attempt to correct the
            fault as soon as we reasonably can.
          </p>
          <p>
            10.3 Your access to the Service may be occasionally restricted or
            interrupted to allow for repairs, maintenance or the introduction of
            new facilities or services or because we are unable to offer the
            Service for reasons beyond our control (such as a denial of service
            attack). In this event we will attempt to restore the Service as
            soon as we reasonably can. Access to the Apps may be restricted
            whether or not you have registered with us. Any such restrictions or
            interruptions shall not constitute a breach by us of these Terms.
          </p>
          <p>
            10.4 Whilst our Apps make use of third-party services or third-party
            websites, we cannot guarantee the availability of any such third
            party services or websites.
          </p>

          <h4>11. Our Liability</h4>
          <p>
            11.1 We will operate the Apps and the Service with the reasonable
            skill and care of an online service provider. The services provided
            do not extend to detailed monitoring or supervision of Content or
            user registrations with the Apps.
          </p>
          <p>
            11.2 Our liability is limited to the fullest extent permitted by
            law.
          </p>
          <p>
            11.3 We will not be liable for unavailability of the Service or the
            Apps, or unavailability of any third-party services or websites
            which we may use.
          </p>
          <p>
            11.4 We are not responsible for the quality of any Products supplied
            by our Providers and we provide no guarantee, representation or
            warranty that Orders will be provided in a timely manner.
          </p>
          <p>
            11.5 The Service may allow its users to distribute Content and use
            the Service without detailed oversight or monitoring. While we put
            systems in place to allow for users and other third parties to
            report harassment, improper use of the Service and distribution of
            offensive, inaccurate, misleading, defamatory, fraudulent or illegal
            Content, we do not make any warranties or guarantees in relation to
            use of the Service and the Apps.
          </p>
          <p className="bold">
            11.6 We will not be liable for any a) business loss; b) financial
            loss; c) economic loss; d) consequential loss; e) loss of data; f)
            lost profit; f) loss of bargain or opportunity or f) indirect loss
            arising as a result of your use of the Service even if such loss is
            incurred or suffered as a result of our negligence or otherwise.
          </p>
          <p className="bold">
            11.7 We will not be liable for any breach of the Data Protection Act
            2018, the General Data Protection Regulation or any other applicable
            legislation relating to the protection of personal data in the event
            that you disclose personally identifiable information relating to
            any third party.
          </p>
          <p>
            11.8 Nothing in these Terms will limit our liability for fraud or
            for death or personal injury caused as a result of our negligence.
          </p>
          <p>
            11.9 In the event that you have a dispute with any other user of our
            Service arising from their use of the Service, you agree to pursue
            such claim or action independently of us, and you release us from
            all claims, liability and damages arising from any such dispute.
          </p>

          <h4>12.Cancellation and Termination of Account</h4>
          <p>
            12.1 If you wish to cancel your Account you can do so by emailing us
            at hello@mylocale.co.uk. On receipt of a communication from you to
            us cancelling your registration, we will delete your Account. We
            reserve the right to delete any data you have published on the Apps
            through your use of the Service (e.g. reviews of Providers). Please
            note that any such data may continue to be accessible in search
            engine caches or on other sites and we cannot agree to delete such
            content.
          </p>
          <p>
            12.2 We reserve the right to terminate your Account immediately
            without notice if in our opinion you have breached these Terms. In
            the event of termination, we will delete your Account and you will
            no longer have access to the Service.
          </p>
          <h4>13.Data Security and Privacy</h4>

          <p>
            13.1 We request that all personal information that you provide is
            accurate, current and complete.
          </p>
          <p>
            13.2 Any information that you provide to us in using the Apps and
            the Service (for instance on your Account log-in details and payment
            details), including sensitive and personal information, will be held
            and processed by us in accordance with our Privacy Policy, which can
            be found <a href="/privacy">here.</a> Your rights concerning your
            personal data and how we process it are contained within our Privacy
            Policy.
          </p>
          <p>
            13.3 You are responsible for ensuring that any other person has
            given the appropriate consents if you upload their personal
            information in your use of the Service.
          </p>
          <p>
            13.4 All notices sent to you will be sent to the email address
            provided with your registration details (as updated by you). By
            accepting these Terms, you give your consent to receive
            communications from us by email and you agree that all agreements,
            notices, disclosures and other communications that we provide to you
            by email satisfy any legal requirement that such communications be
            in writing.
          </p>
          <p>
            13.5 If we have reason to believe that there is likely to be a
            breach of security or misuse of the Service or the Apps through your
            Account or the use of your password, we may notify you by email and
            require you to change your passwords on our system and with your
            other suppliers, or we may suspend your Account until you have done
            so. Until you have changed all your passwords, or we have
            reactivated your Account you will not be able to access the Service.
          </p>
          <h4>14.Other Sites and Services</h4>
          <p>
            The Apps include links to other websites, services or materials
            which are beyond our control. We are not responsible for content or
            services outside the Service.
          </p>
          <h4>15.Intellectual Property and App Licence</h4>
          <p>
            15.1 If you have downloaded a copy of our Apps, then subject to your
            agreement to these Terms we hereby grant a non-exclusive,
            non-transferable licence to download a copy of the Apps to such
            devices as are personally used by you and to use the Apps for your
            personal purposes. You may also take back-up copies of the Apps for
            personal use. We reserve the right to terminate this licence if you
            are in breach of these Terms. You may not transfer this licence.
          </p>
          <p>
            15.2 By providing Content for distribution by the Service you
            expressly grant us a royalty-free, perpetual, irrevocable licence to
            use such Content in order to deliver the Service to you.
          </p>
          <p>
            15.3 The format and content of the Apps (including but not limited
            to the Service layout, codes, systems and logic of organisation) is
            protected by United Kingdom and international copyright and we
            reserve all rights in relation to our copyright whether owned or
            licensed to us and all rights are reserved to any of our registered
            and unregistered trademarks (whether owned or licensed to us) which
            appear on the Apps.
          </p>
          <p>
            15.4 You may not use, copy, modify or transfer the Apps or any
            materials or documents we have supplied to you except as expressly
            set out in these terms. You may not translate, reverse engineer,
            decompile, disassemble, modify or create derivative works based on
            the Apps, except as expressly permitted by law.
          </p>
          <p>
            15.5 The Apps and Services may not be reproduced, duplicated,
            copied, sold, resold, visited, or otherwise exploited for any
            commercial purpose without our express written consent. You may not
            systematically extract and/or re-utilise parts of the contents of
            the Apps without our express written consent.
          </p>
          <p>
            15.6 You are not entitled to use any data mining, robots, or similar
            data gathering and extraction tools to collect user names, e-mail
            addresses or any other data for the purposes of sending unsolicited
            e-mail or for any other use.
          </p>
          <p>
            15.7 We reserve all rights to the name ‘Local E’ and any other
            trading style used in connection with the Service.
          </p>
          <h4>16.Notice and Take-Down</h4>

          <p>
            16.1 We will make all reasonable efforts to delete Accounts which
            are being used in breach of our Terms and to identify and remove
            Content that is defamatory or infringing on intellectual property
            rights when we are notified but we cannot be responsible if you have
            failed to provide the relevant information.
          </p>
          <p>
            16.2 In the event that you believe that an Account is being used in
            an inappropriate manner or that any Content which is distributed
            using the Service is defamatory or infringing on intellectual
            property rights you should notify us in writing either by email to{" "}
            <a href="mailto:hello@mylocale.co.uk">hello@mylocale.co.uk</a>{" "}
            including the following:
          </p>
          <ul
            style={{
              paddingLeft: "20px",
              marginBottom: "15px",
              listStyle: "disc"
            }}
          >
            <li style={{ fontSize: "12px" }}>
              Your full name and contact details, including postal address,
              telephone number and e-mail address;
            </li>
            <li style={{ fontSize: "12px" }}>
              The location where the defamatory or infringing content appears;
            </li>
            <li style={{ fontSize: "12px" }}>
              The content that you believe is defamatory or infringing on
              intellectual property rights;
            </li>
            <li style={{ fontSize: "12px" }}>
              The reasons that you believe the content is defamatory or
              infringing on intellectual property rights;
            </li>
            <li style={{ fontSize: "12px" }}>
              A statement confirming that you are authorised to act on behalf of
              the claimant or rights holders; and
            </li>
            <li style={{ fontSize: "12px" }}>
              A signed declaration truth in respect of the information in the
              notice.
            </li>
          </ul>
          <p>
            16.3 Any statement made under this clause may be used in court
            proceedings.
          </p>
          <h4>17.International Use</h4>
          <p>
            You shall comply with all foreign and local laws and regulations
            which apply to your use of our Apps in whatever country you are
            physically located, including without limitation, consumer law,
            export control laws and regulations.
          </p>

          <h4>18.General</h4>
          <p>
            18.1 These conditions are governed by and construed in accordance
            with the laws of England and Wales. You agree, as we do, to submit
            to the non-exclusive jurisdiction of the English courts.
          </p>
          <p>
            18.2 If you breach these Terms and we decide to take no action or
            neglect to do so, then we will still be entitled to take action and
            enforce our rights and remedies for any other breach.
          </p>
          <p>
            18.3 We will not be responsible for any breach of these Terms caused
            by circumstances beyond our reasonable control.
          </p>
        </div>
      </div>
    );
  }
}

export default Terms;
